import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

export default function BDateFormInput({ 
  placeholder, 
  fieldName, 
  control, 
  validation
}) {
  const [selectValue, setSelectValue] = useState({});

  const handleInputChange = (e) => {
    if (e == null) {
      return null;
    }
    const value = e.target.value;
    
    setSelectValue(value);
    return value.replace(/\s/g, "").split(',');
  };
  const getPreloadedDataFromControl = () => {
    return control.defaultValuesRef &&
      control.defaultValuesRef.current[`${fieldName}`]
      ? control.defaultValuesRef?.current[`${fieldName}`].join(", ")
      : "";
  };

  useEffect(() => {
    setSelectValue(getPreloadedDataFromControl());
  }, []);

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange }, rules }) => (
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder={placeholder}
          onChange={(e) => onChange(handleInputChange(e))}
          value={selectValue}
        />
      )}
      rules={validation}
    />
  );
}

BDateFormInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  validation: PropTypes.object,
  control: PropTypes.object.isRequired,
};
